import { Dispatch } from "redux";
import { createActionCreator, createReducer } from "deox";
import * as productService from "../services/products";
import { ProductInterface } from "../models/products";

export type State = {
  singleProduct: ProductInterface | null;
  oneOfAKind: ProductInterface[] | null;
  studs: ProductInterface[] | null;
  brooch: ProductInterface[] | null;
  bridal: ProductInterface[] | null;
  pendants: ProductInterface[] | null;
  classic: ProductInterface[] | null;
  necklaces: ProductInterface[] | null;
  eternityBand: ProductInterface[] | null;
};

const defaultState: State = {
  singleProduct: null,
  oneOfAKind: null,
  studs: null,
  brooch: null,
  bridal: null,
  pendants: null,
  classic: null,
  necklaces: null,
  eternityBand: null,
};

const fetchAll = Object.assign(
  () => async (dispatch: Dispatch) => {
    try {
      const result = await productService.getAll();
      dispatch(fetchAll.success(result));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator("@@PRODUCTS/ALL/FETCH", resolve => (data: ProductInterface[]) => {
      const norm = (v: any) => String(v ?? "").trim().toLowerCase();

      const allowed = new Set(["ring", "necklace", "pendant", "earrings", "bracelet", "brooch"]);
      const isAvailable = (p: ProductInterface) => norm(p.status) === "available";
      const typeIs = (p: ProductInterface, type: string) => norm(p.type) === type;

      const oneOfAKind = data.filter(p => isAvailable(p) && allowed.has(norm(p.type)));
      const pendants = data.filter(p => isAvailable(p) && typeIs(p, "pendant"));
      const necklaces = data.filter(p => isAvailable(p) && typeIs(p, "necklace"));
      const brooches = data.filter(p => isAvailable(p) && typeIs(p, "brooch"));

      return resolve({ oneOfAKind, pendants, necklaces, brooches });
    }),
  }
);

const fetchSingleProduct = Object.assign(
  (stockNumber: string) => async (dispatch: Dispatch) => {
    try {
      const result = await productService.getSingleProduct(stockNumber);
      dispatch(fetchSingleProduct.success(result));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator(
      "@@PRODUCTS/SINGLE_PRODUCT/FETCH",
      resolve => (data: ProductInterface) => resolve(data)
    ),
  }
);

const clearSingleProduct = createActionCreator(
  "@@PRODUCTS/SINGLE_PRODUCT/CLEAR",
  resolve => () => resolve()
);


// Create a reducer to handle the fetch actions
const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchAll.success, (state, action) => ({ ...state, ...action.payload })),
  handleAction(fetchSingleProduct.success, (state, action) => ({ ...state, singleProduct: action.payload })),
  handleAction(clearSingleProduct, state => ({
    ...state,
    singleProduct: null,
  })),
]);

// Export fetch actions and reducer
const actions = {
  fetchAll,
  fetchSingleProduct,
  clearSingleProduct
};

export { actions, reducer };
